import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmb-details-information-field',
  imports: [],
  templateUrl: './details-information-field.component.html',
  styleUrl: './details-information-field.component.scss',
})
export class DetailsInformationFieldComponent {
  @Input() label: string;
  @Input() value: string;
}
